import TemplateNames from './TemplateNames';

export default {
  title: 'Email automatiche',
  labels: {
    empty_list: 'Nessun template trovato',
    load_failed: "Impossibile caricare le tue email automatiche. Ricarica la pagina o contatta l'assistenza.",
    on: 'Attivo',
    off: 'Disattivo',
  },
  fields: {
    name: 'Nome',
    messages_delivered: 'Messaggi consegnati',
    open_rate: 'Tasso di apertura',
    click_rate: 'Tasso di clic',
    status: 'Stato',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Aggiornamento stato non riuscito',
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
